export default "__VITE_ASSET__C34pMQGT__"